<!--
* @Name：供应商营业业绩
* @Author: 王超
* @Date: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in suppInfoList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>营业范围：</span>
        <span>{{ item.businessScope }}</span>
      </van-row>
      <van-row>
        <span>公司业绩：</span>
        <span>{{ item.companyPerformance }}</span>
      </van-row>
      <van-row>
        <span>合作客户：</span>
        <span>{{ item.customerNames }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'suppInfoList',
  data() {
    return {}
  },
  props: {
    suppInfoList: {
      type: Array,
      required: true
    }
  },
  computed: {
    enterpriseTypeDictOptions() {
      return this.$store.getters.dicts.enterprise_character
    },
    quoteStatusDictOptions() {
      return this.$store.getters.dicts.quote_status
    }
  }
}
</script>
